<template>
  <ContentBox :title="'前哨资讯'">
    <div class="out-post">
      <Header :title="'前哨资讯'"/>
      <div class="out-post-container">
        <div class="container-list">
          <div class="list-header">企业资讯</div>
          <div class="list-item">
            <div class="list-item-l">极乐净土</div>
            <div class="list-item-r">lv.{{ outPost.elysion_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">泰特拉</div>
            <div class="list-item-r">lv.{{ outPost.tetra_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">朝圣者</div>
            <div class="list-item-r">lv.{{ outPost.pilgrim_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">米西利斯</div>
            <div class="list-item-r">lv.{{ outPost.missills_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">反常</div>
            <div class="list-item-r">lv.{{ outPost.abnormal_level }}</div>
          </div>
        </div>
        <div class="container-list">
          <div class="list-header">职业等级</div>
          <div class="list-item">
            <div class="list-item-l">火力型</div>
            <div class="list-item-r">lv.{{ outPost.attacker_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">防御型</div>
            <div class="list-item-r">lv.{{ outPost.defender_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">辅助型</div>
            <div class="list-item-r">lv.{{ outPost.supporter_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">同步等级</div>
            <div class="list-item-r">lv.{{ outPost.sychro_level }}</div>
          </div>
          <div class="list-item">
            <div class="list-item-l">循环实研究等级</div>
            <div class="list-item-r">lv.{{ outPost.recyle_level }}</div>
          </div>
        </div>
      </div>
      <div class="container-bottom">
        <div class="bottom-block bottom-block-l"></div>
        <div class="bottom-block bottom-block-r"></div>
      </div>
    </div>
  </ContentBox>
</template>
<script>
import ContentBox from "./ContentBox.vue"

export default {
  name: "OutPost",
  props: {
    outPost: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    ContentBox
  },
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">
.out-post {
  margin-bottom: 10px;
  border-radius: 0 0 10px 10px;

  .out-post-container {
    width: 100%;
    padding: 14px 14px 5px 14px;
    background: #fafbfc;
    border-radius: 0 0 10px 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    .container-list {
      display: flex;
      flex-direction: column;
      gap: 5px;

      .list-header {
        text-indent: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 28px;
        background: #3490E6;
        border-radius: 15px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
      }

      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 25px;
        background: #ffffff;

        .list-item-l {
          margin-left: 5px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
        }

        .list-item-r {
          font-weight: 500;
          font-size: 12px;
          color: #333333;
          margin-right: 5px;
        }
      }
    }
  }

  .container-bottom {
    width: 100%;
    height: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;

    .bottom-block {
      width: 8px;
      height: 2px;
      background: #3490e6;
    }

    .bottom-block-l {
      margin-left: 14px;
    }

    .bottom-block-r {
      margin-right: 14px;
    }
  }
}
</style>
